<template>
    <div class="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <div class="flex justify-center">
                <AppLogo :appName="appName" />
            </div>
            <h2
                class="mt-6 text-center text-xl font-bold leading-9 tracking-tight text-gray-900"
            >
                <slot name="title" />
            </h2>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full sm:max-w-[480px] px-4 lg:px-0">
            <div
                class="bg-white px-6 py-12 border border-stone-200 shadow-xs rounded-xl sm:px-12"
            >
                <FlashMessage />

                <slot name="card-content" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onBeforeMount } from 'vue'
    import FlashMessage from '@/Shared/Component/FlashMessage.vue'
    import AppLogo from '@/Shared/Component/AppLogo.vue'
    import { type FlashStatusType } from '@/Shared/AutoGenerated/Main'
    import useFlash from '@/Shared/Hook/useFlash'

    interface AuthLayoutProps {
        appName: string
        flashStatus: FlashStatusType | null
    }

    const props = defineProps<AuthLayoutProps>()

    onBeforeMount(() => {
        if (!props.flashStatus) {
            return
        }

        useFlash().display(props.flashStatus)
    })
</script>
